/**
 * Terminology overrides applied on top of the main translations when the company is a cooperative
 * society. Only the keys that differ are listed here.
 */
const cooperative = {
	en: {
		translation: {
			TITLE: {
				COMPANY_INFORMATION: 'Society Information',
				SHAREHOLDERS_REGISTRY: 'Member Register',
				CAP_TABLE: 'Member Shareholdings',
				TRANSACTIONS_LOGS: 'Share Assignment Log',
			},
			PAGES: {
				COMPANY_INFORMATION: 'Society Information',
				SHAREHOLDERS_REGISTRY: 'Member Register',
				SHAREHOLDERS_LIST: 'Member Register',
				CAP_TABLE: 'Member Shareholdings',
				TRANSACTIONS_LOGS: 'Share Assignment Log',
				SHAREHOLDER_INFO: 'Member Information',
				DIVIDENDS: 'Surplus Distribution',
				COMPANY_DOCUMENTS: 'Society Documents',
			},
			SIDEBAR: {
				COMPANY_INFORMATION: 'Society Information',
				SHAREHOLDERS_REGISTRY: 'Member Register',
				SHAREHOLDERS_LIST: 'Member Shares',
				CAP_TABLE: 'Ownership Structure',
				ADD_SHAREHOLDERS_REGISTRY: 'Add Member Register',
				VIEW_SHAREHOLDERS_REGISTRY: 'View Member Register',
				UPDATE_SHAREHOLDERS_REGISTRY: 'Update Member Register',
				ADD_COMPANY_DOCUMENTS: 'Upload Society Documents',
				VIEW_COMPANY_DOCUMENTS: 'View Society Documents',
				UPDATE_COMPANY_DOCUMENTS: 'Update Society Documents',
			},
			DOCUMENTS: {
				UPLOAD_DOCUMENTS: 'Upload Society Documents',
				DOCUMENTS_REVIEW: 'Society Documents Review',
				PLEASE_UPLOAD_DESC: 'In order to activate your account, please upload your society’s documents.',
				COMPANY_ESTABLISHMENT: 'Current Society Establishment Contract',
				CERTIFIED_COMPANY_VALUATION: 'Certified society valuation and share value (If any)',
			},
			DASHBOARD: {
				AVERAGE_SALE_PRICE: 'Share Value',
				SHAREHOLDERS: 'Members',
				ANNUAL_TRAFFIC: 'Annual Transfer Volume',
				ACTIVATE_ACCOUNT: 'Dear User, the society account has been approved. Please activate it.',
				SHAREHOLDERS_APPROVED: 'The society member register has been approved successfully and you can view it from here.',
				PLEASE_ADD_SHAREHOLDERS: 'please add the cooperative society members',
				YOU_CAN_UPLOAD_SHAREHOLDERS: 'You can upload the cooperative society members registry and send it to the system',
				PLEASE_UPLOAD_DOCUMENTS: 'Please upload the cooperative society documents',
				YOU_CAN_UPLOAD_DOCUMENTS: 'You can upload the cooperative society documents and send them to the system',
				SHAREHOLDERS_UPLOADED: 'The cooperative society members registry has been successfully uploaded and sent to the system, and you can view it.',
				DOCUMENTS_UPLOADED: 'The cooperative society documents have been successfully uploaded and sent to the system, and you can view them.',
				SHAREHOLDERS_SHARES: 'Members Shares',
			},
			ACTIONS: {
				SHAREHOLDER_INFO: 'Member Information',
				SHAREHOLDERS_LIST: 'Member Register',
				DIVIDENDS: 'Surplus Distribution',
				INTERIM_DIVIDENDS: 'Interim Surplus',
				ANNUAL_DIVIDENDS: 'Annual Surplus',
				REVENUE_PER_SHARE: 'Return per Share',
				CHAIRMAN: 'Chairman',
				VICE_CHAIRMAN: 'Vice Chair',
				SECRETARY: 'Board Secretary',
				'BOARD-CHAIR': 'Chairman',
				'VICE-CHAIRMAN': 'Vice Chair',
				'BOARD-SECRETARY': 'Board Secretary',
				SHAREHOLDER_LIMIT_EXCEEDED_DESCRIPTION:
					"The member's shareholding exceeds 10%, and the transaction requires exceptional approval from the Board of Directors.",
				COMPANY_SHARES_LIMIT_EXCEEDED: 'The number of shares exceeds the maximum allowed limit in the cooperative society system remaining {{count}} shares',
			},
			COMPANY_INFORMATION: {
				SHAREHOLDERS_LIST: 'Member Register',
				CAP_TABLE: 'Member Shareholdings',
				TRANSACTIONS_LOGS: 'Share Assignment Log',
				COMPANY_APPROVAL_ON_TRANSFER_REQUESTS: 'Board Approval of Assignments',
				TOTAL_COMMON_SHARES: 'Number of Shares',
				COMPANY_CAPITAL_IN_SAR: 'Society Capital',
				COUNT_OF_FREE_COMMON_SHARES: 'Free Shares',
				COUNT_OF_SUSPENDED_COMMON_SHARES: 'Suspended Shares',
				COUNT_OF_MORTGAGED_COMMON_SHARES: 'Mortgaged Shares',
				COMPANY_AR_NAME: 'Society Name in Arabic',
				COMPANY_EN_NAME: 'Society Name in English',
				COMPANY_MANAGER_AR_NAME: 'Society Manager Name in Arabic',
				COMPANY_MANAGER_EN_NAME: 'Society Manager Name in English',
				COMPANY_LOGO: 'Society Logo',
				MAJOR_SHAREHOLDERS_DESC: "Those who own 5% or more of the society's shares",
			},
		},
	},
	ar: {
		translation: {
			TITLE: {
				COMPANY_INFORMATION: 'معلومات الجمعية التعاونية',
				SHAREHOLDERS_REGISTRY: 'سجل الأعضاء',
				CAP_TABLE: 'اسهم الاعضاء',
				TRANSACTIONS_LOGS: 'سجل التنازل عن الأسهم',
			},
			PAGES: {
				COMPANY_INFORMATION: 'معلومات الجمعية التعاونية',
				SHAREHOLDERS_REGISTRY: 'سجل الأعضاء',
				SHAREHOLDERS_LIST: 'سجل الأعضاء',
				CAP_TABLE: 'اسهم الاعضاء',
				TRANSACTIONS_LOGS: 'سجل التنازل عن الأسهم',
				SHAREHOLDER_INFO: 'معلومات عضو',
				DIVIDENDS: 'توزيع الفائض',
				COMPANY_DOCUMENTS: 'مستندات الجمعية التعاونية',
			},
			COMMON: {
				SHAREHOLDER: 'العضو',
				SHAREHOLDER_FULL_NAME: 'اسم العضو',
				SHAREHOLDERS: 'الأعضاء',
				REGISTRY_AMENDMENTS: 'تعديل سجل الأعضاء',
			},
			SIDEBAR: {
				COMPANY_INFORMATION: 'معلومات الجمعية التعاونية',
				SHAREHOLDERS_REGISTRY: 'سجل الأعضاء',
				SHAREHOLDERS_LIST: 'أسهم الأعضاء',
				CAP_TABLE: 'هيكل الملكية',
				ADD_SHAREHOLDERS_REGISTRY: 'ادخال سجل الأعضاء',
				VIEW_SHAREHOLDERS_REGISTRY: 'عرض سجل الأعضاء',
				UPDATE_SHAREHOLDERS_REGISTRY: 'تعديل سجل الأعضاء',
				ADD_COMPANY_DOCUMENTS: 'رفع مستندات الجمعية التعاونية',
				VIEW_COMPANY_DOCUMENTS: 'عرض مستندات الجمعية التعاونية',
				UPDATE_COMPANY_DOCUMENTS: 'تحديث مستندات الجمعية التعاونية',
			},
			DOCUMENTS: {
				UPLOAD_DOCUMENTS: 'تحميل مستندات الجمعية التعاونية',
				DOCUMENTS_REVIEW: 'مراجعة مستندات الجمعية التعاونية',
				COMPANY_ESTABLISHMENT: 'عقد تأسيس الجمعية التعاونية الحالى',
				CERTIFIED_COMPANY_VALUATION: 'تقييم معتمد للجمعية التعاونية وقيمة السهم(إن وجد)',
			},
			SHAREHOLDERS_REGISTRY: {
				ADD: 'إضافة سجل الأعضاء',
				ADDED: 'سجل الأعضاء المرسل الى النظام',
				ADD_DESC: 'يمكنك إضافة الأعضاء يدويا او رفع السجل في النظام',
				ADD_NEW_SHAREHOLDER: 'إضافة عضو',
				ADD_ALL_DATA_MANUALLY: 'فضلا ادخال بيانات العضو بشكل صحيح',
				SHAREHOLDER_ADDED: 'تم إضافة بيانات العضو بنجاح',
				SHAREHOLDER_UPDATED: 'تم تحديث بيانات العضو بنجاح',
				SAVED_FOR_LATER: 'تم حفظ قائمة الأعضاء للرجوع إليها لاحقًا',
				SENT_FOR_REVIEW_SUCCESS: 'تم إرسال قائمة الأعضاء للمراجعة بنجاح',
				DELETE_SHAREHOLDER_CONFIRM: 'هل أنت متأكد أنك تريد حذف هذا العضو؟',
				SHAREHOLDER_DELETED: 'تم حذف العضو بنجاح',
				TOTAL_SHAREHOLDERS: 'إجمالي عدد الأعضاء',
				SHAREHOLDER_COMMON_SHARES: 'الأسهم العادية المملوكة للعضو',
			},
			DASHBOARD: {
				AVERAGE_SALE_PRICE: 'قيمة السهم',
				SHAREHOLDERS: 'الأعضاء',
				ANNUAL_TRAFFIC: 'الحجم السنوي للتناقل',
				ACTIVATE_ACCOUNT: 'عزيزى المستخدم تم اعتماد حساب الجمعية فضلا تفعيله.',
				SHAREHOLDERS_APPROVED: 'تم اعتماد سجل الأعضاء بنجاح ويمكنك الاطلاع عليه .',
				PLEASE_ADD_SHAREHOLDERS: 'فضلا إضافة سجل اعضاء الجمعية التعاونية ',
				YOU_CAN_UPLOAD_SHAREHOLDERS: 'من هنا يمكنك رفع سجل اعضاء الجمعية التعاونية وارساله الى النظام ',
				PLEASE_UPLOAD_DOCUMENTS: 'فضلا ارفاق مستندات الجمعية التعاونية',
				YOU_CAN_UPLOAD_DOCUMENTS: 'من هنا يمكنك رفع مستندات الجمعية التعاونية وارسالها الى النظام',
				SHAREHOLDERS_UPLOADED: 'تم ادخال سجل اعضاء الجمعية التعاونية وارسالة للنظام بنجاح ويمكنك الاطلاع عليه .',
				DOCUMENTS_UPLOADED: 'تم رفع مستندات الجمعية التعاونية وارسالها للنظام بنجاح ويمكنك الاطلاع عليها .',
				SHAREHOLDERS_SHARES: 'أسهم الأعضاء',
				SHAREHOLDERS_REJECTED: 'تم إعادة سجل الأعضاء .. فضلا التحقق من صحته',
				SHAREHOLDERS_WAITING_APPROVAL: 'الأعضاء في انتظار الموافقة الإدارية حاليًا',
				UPDATE_SHAREHOLDERS_REGISTRY_DESC: 'يرجى تحديث سجل الأعضاء الخاص بك لتفعيل حسابك',
				UPDATE_SHAREHOLDERS_REGISTRY: 'تحديث سجل الأعضاء',
			},
			ACTIONS: {
				SHAREHOLDER_INFO: 'معلومات عضو',
				VIEW_SHAREHOLDERS: 'عرض معلومات عضو وإنشاء شهادة الملكية',
				SHAREHOLDER_NATIONAL_ID: 'الهوية الوطنية للعضو',
				SHAREHOLDER_NAME: 'اسم العضو',
				SHAREHOLDER_CERTIFICATE: 'شهادة العضو',
				NAME_OF_DECEASED: 'اسم العضو المتوفى',
				SEND_NOTICE_TO_ALL_SHAREHOLDERS: 'إرسال تبليغ لكل الأعضاء',
				SEND_NOTICE_TO_SPECIFIC_SHAREHOLDER: 'إرسال تبليغ لعضو معين',
				SHOW_ON_PLATFORM_CONNECTED_TO_HEFTH: 'عرضها على الأعضاء في المنصات المرتبطة بحفظ',
				TO_SENT_TO_SHAREHOLDERS: 'نشر القوائم للأعضاء و ملف الجمعية في التطبيقات',
				BROADCAST_ANNOUNCEMENT: 'ارسال رسالة نصية لأعضاء الجمعية',
				NOTIFY_SHAREHOLDERS: 'تبليغ الأعضاء',
				ADD_ALL_FILES_TO_ASSEMBLY: 'فضلا اضافة جميع المستندات الخاصة بالجمعية لعرضها على الأعضاء',
				ASSEMBLY_SHAREHOLDER: 'العضو نفسه',
				SHAREHOLDER: 'العضو نفسه',
				SHAREHOLDER_FULL_NAME: 'اسم العضو الكامل',
				EACH_SHAREHOLDER_REPRESENT_ONE_VOTE: 'كل عضو يمثل صوت واحد',
				SHAREHOLDER_NOT_FOUND: 'العضو غير موجود',
				SELLER_AND_BUYER_CANNOT_BE_SAME: 'لا يمكن أن يكون البائع والمشتري نفس العضو',
				SHAREHOLDER_LIMIT_EXCEEDED_DESCRIPTION: 'نسبة الاسهم للعضو تتخطى ١٠٪ و العملية تتطلب موافقة استثنائية من مجلس الادارة',
				SHAREHOLDER_GENERATED_SUCCESSFULLY: 'تم إنشاء العضو بنجاح',
				CANCEL_REQUEST_NOTE: 'عند تاكيد طلب الالغاء يمكن لكل الأعضاء التصرف بملكيتهم بشكل فوري. فضلا التاكد من سلامة الاجراء.',
				WHEN_YOU_PUBLISH: 'عند نشرك للاعلان سيصل رسالة (SMS) لأعضاء الجمعية',
				CONFIRM_SEND_SHAREHOLDERS: 'قم بتأكيد طلبك بإرسال رسائل نصية قصيرة (SMS) إلى الأعضاء.',
				NUMBER_OF_SHAREHOLDER_ADDED_VOTES: 'عدد الأعضاء الذين قاموا بالتصويت',
				NUMBER_OF_SHAREHOLDER_ADDED_NO_VOTES: 'عدد الأعضاء الذين لم يصوتون',
				SUBMIT_SHAREHOLDER_VOTE: 'إضافة تصويت العضو',
				VOTE_ADDED_SUCCESSFULLY: 'تم إضافة تصويت العضو بنجاح',
				SHAREHOLDER_VOTING_CARDS: 'بطاقات تصويت الأعضاء',
				SPECIFIC_SHAREHOLDERS: 'أعضاء محددون',
				PROFIT_CAPITALIZATION_DESC: 'توزيع أسهم مجانية لجميع الأعضاء برسمية الارباح المبقاة.',
				TREASURY_SHARES_ACQUISITION_DESC: 'انشاء امر لشراء اسهم من جميع الأعضاء الحاليين',
				SHAREHOLDERS_DIVIDENDS_LIST: 'قائمة أرباح الأعضاء',
				ABSTEEN_SHAREHOLDERS: 'استثناء عضو',
				ABSTEENED_SHAREHOLDERS: 'قائمة الأعضاء المستثنون من التوزيع',
				SHAREHOLDER_DIRECT_IBAN_TRANSFER: 'تحويل مباشر لحساب العضو البنكي',
				DIRECT_TRANSFER_TO_IBAN: 'قائمة الأعضاء المشمولين في التحويل المباشر',
				ABSTEEN_SHAREHOLDERS_INFO: 'التحفظ على أرباح عضو محدد لأسباب إدارية او مالية او قضائية',
				SHAREHOLDER_ALREADY_ADDED: 'العضو مضاف بالفعل',
				DELETE_SHAREHOLDER_CONFIRMATION: 'تأكيد حذف العضو',
				SUSPEND_REASON_TOOLTIP: 'سبب التعليق الذي يظهر للأعضاء',
				UPLOAD_DOCUMENTS_TOOLTIP: 'المستندات التي تظهر للأعضاء',
				SHAREHOLDERS_LIST: 'سجل الأعضاء',
				DIVIDENDS: 'توزيع الفائض',
				INTERIM_DIVIDENDS: 'فائض مرحلي',
				ANNUAL_DIVIDENDS: 'فائض سنوي',
				REVENUE_PER_SHARE: 'عائد السهم',
				CHAIRMAN: 'رئيس المجلس',
				VICE_CHAIRMAN: 'نائب الرئيس',
				SECRETARY: 'أمين المجلس',
				'BOARD-CHAIR': 'رئيس المجلس',
				'VICE-CHAIRMAN': 'نائب الرئيس',
				'BOARD-SECRETARY': 'أمين المجلس',
				COMPANY_SHARES_LIMIT_EXCEEDED: 'عدد الأسهم يتجاوز الحد الاقصى المسوح بها في نظام الجمعيات (المتبقي {{count}} سهم)',
			},
			COMPANY_INFORMATION: {
				SHAREHOLDERS_LIST: 'سجل الأعضاء',
				CAP_TABLE: 'اسهم الاعضاء',
				TRANSACTIONS_LOGS: 'سجل التنازل عن الأسهم',
				COMPANY_APPROVAL_ON_TRANSFER_REQUESTS: 'موافقة مجلس الإدارة على التنازل',
				TOTAL_COMMON_SHARES: 'عدد الأسهم',
				COMPANY_CAPITAL_IN_SAR: 'رأس مال الجمعية التعاونية',
				COUNT_OF_FREE_COMMON_SHARES: 'الأسهم الحرة',
				COUNT_OF_SUSPENDED_COMMON_SHARES: 'الأسهم المعلقة',
				COUNT_OF_MORTGAGED_COMMON_SHARES: 'الأسهم المرهونة',
				NAME_OF_SHAREHOLDER: 'اسم العضو',
				COMPANY_AR_NAME: 'اسم الجمعية التعاونية باللغة العربية',
				COMPANY_EN_NAME: 'اسم الجمعية التعاونية باللغة الإنجليزية',
				COMPANY_MANAGER_AR_NAME: 'اسم مدير الجمعية التعاونية باللغة العربية',
				COMPANY_MANAGER_EN_NAME: 'اسم مدير الجمعية التعاونية باللغة الإنجليزية',
				COMPANY_LOGO: 'شعار الجمعية التعاونية',
				MAJOR_SHAREHOLDERS_DESC: 'من يملكون 5% واكثر من أسهم الجمعية التعاونية',
			},
			USERS_MANAGEMENT: {
				SHAREHOLDER_INFORMATION: 'عرض معلومات العضو',
			},
		},
	},
};

export default cooperative;
